<template>
  <form @submit.prevent="submit">
    <main class="flex-item">
      <div class="card">
        <header class="card-header page-title">
          <p class="card-header-title is-size-4"><span class="material-icons is-size-4">lock</span>パスワード変更</p>
        </header>
        <div class="card-content">
          <div class="field mb-6">
            <label class="label">現在のパスワードを入力してください</label>
            <div class="control has-icons-left has-icons-right">
              <input class="input" type="password" v-model="form.nowPassword" />
              <span class="icon is-small is-left">
                <span class="material-icons">lock</span>
              </span>
              <ErrorField :error="f$.nowPassword.$errors" />
            </div>
          </div>

          <div class="field">
            <label class="label">新しく変更したいパスワードを入力してください</label>
            <div class="control has-icons-left has-icons-right">
              <input class="input" type="password" v-model="form.newPassword" />
              <span class="icon is-small is-left">
                <span class="material-icons">lock</span>
              </span>
              <ErrorField :error="f$.newPassword.$errors" />
            </div>
          </div>

          <div class="field">
            <label class="label">確認のためもう一度入力してください</label>
            <div class="control has-icons-left has-icons-right">
              <input class="input" type="password" v-model="form.newPasswordConfirm" />
              <span class="icon is-small is-left">
                <span class="material-icons">lock</span>
              </span>
              <ErrorField :error="f$.newPasswordConfirm.$errors" />
            </div>
          </div>
        </div>

        <div class="columns is-centered" v-if="g$.length > 0">
          <div class="column is-11">
            <article class="message is-danger">
              <div class="message-body">
                <p v-for="(v, i) in g$" :key="i">{{ v }}</p>
              </div>
            </article>
          </div>
        </div>

        <footer class="card-footer">
          <div class="card-footer-item">
            <span class="mr-4">
              <button class="card-footer-item button is-primary is-normal is-medium" @click.prevent="submit">パスワードを変更する</button>
            </span>
            <span>
              <router-link class="card-footer-item button is-normal is-medium" :to="{ name: 'Top' }">キャンセル</router-link>
            </span>
          </div>
        </footer>
      </div>
    </main>
  </form>
</template>

<script lang="ts">
import { passwordChangeRequest, postPassword } from "@/api/password";
import { SCR240FormValidateRule } from "@/forms/scr240";
import useVuelidate from "@vuelidate/core";
import { defineComponent, reactive, ref, UnwrapRef } from "vue";
import ErrorField from "common/src/components/ErrorField.vue";
import { scrollToError } from "common/src/utils/screen";
import router from "@/router";
import axios from "axios";
import { setErrorMessage } from "common/src/utils/validate";
import { ErrorResponse } from "common/src/utils/request";
import { MutationTypes, useStore } from "@/store";

export default defineComponent({
  components: {
    ErrorField,
  },
  setup() {
    const form: UnwrapRef<passwordChangeRequest> = reactive({
      nowPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
    });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);
    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(SCR240FormValidateRule, form, {
      $externalResults,
    });

    const store = useStore();

    // パスワード変更処理呼び出し
    const submit = async () => {
      g$.splice(0, g$.length);
      f$.value.$touch();
      f$.value.$clearExternalResults();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      try {
        await postPassword(form);

        // パスワード変更必須ステートを書き換え
        store.commit(MutationTypes.PASSWORD_CHANGED);

        router.push({ name: "PasswordChanged" });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
          scrollToError();
        }
      }
    };

    return {
      form,
      g$,
      f$,
      submit,
    };
  },
});
</script>
